import { render } from "./MapContainer.vue?vue&type=template&id=c2a40e5e"
import script from "./MapContainer.vue?vue&type=script&lang=js"
export * from "./MapContainer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/prohemo/education/mental-maps/metal-maps-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__